import { createFileRoute } from '@tanstack/react-router';

import { getActiveClassQueryOptions } from '~entities/classes/api/get-active-class';
import { redirectIfClassMissing } from '~entities/classes/lib/redirect-if-class-missing';

import { StudentAttendanceAll } from '~features/classes';

const Component = () => {
  const { classId } = Route.useParams();
  return <StudentAttendanceAll key={classId} />;
};

export const Route = createFileRoute('/_auth/_layout/attendance/$classId/')({
  loader: async ({ params, context }) => {
    try {
      return await context.queryClient.ensureQueryData(
        getActiveClassQueryOptions(params.classId),
      );
    } catch (error) {
      redirectIfClassMissing(error);
      throw error;
    }
  },
  component: Component,
});
